import React, { PropsWithChildren } from 'react'
import { styled } from '@mui/material'
import {
  Account as AccountIcon,
  Logout as LogoutIcon,
} from 'icons'
import MenuList from '@mui/material/MenuList'
import Divider from '@mui/material/Divider'
import { Box, MenuLink, Text } from 'components'
import { useMe, useLogout, useViewport } from 'hooks'
import { Account, SchoolLocation, Term, VendorLocation } from 'graphql/schema/graphql'
import { NavMenuItemWrapper } from './NavMenuItem'
import { AppName } from 'hooks/useBaseUrl'

const MenuBox = styled(Box)({
  position: 'relative',
  ['a']: {
    width: '100%'
  }
})

const AccountBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // cursor: 'pointer',
})

export type FooterProps = PropsWithChildren<{
  onClick: React.MouseEventHandler,
  appName: AppName
  me: ReturnType<typeof useMe>,
  currentLocation?: SchoolLocation | VendorLocation,
  currentTerm?: Term
  currentAccount?: Account
  AccountMenuItems: React.FC<{ me: ReturnType<typeof useMe>, onClick?: React.MouseEventHandler }>
  accountMenuOpen: boolean
  setAccountMenuOpen: (open: boolean) => void
}>

export const Footer: React.FC<FooterProps> = ({ me, AccountMenuItems, onClick }) => {
  const { me: user } = me
  const logout = useLogout(false)
  const { isLarge } = useViewport()

  if (!user) return null
  if (isLarge) return null

  return <Box>
    <Divider />

    <AccountBox pl={2} pr={3} pt={2}>
      <Box flexGrow="0">
        <Text color="grey" variant="h4" height="34px" width="34px">
          <AccountIcon fontSize="inherit" />
        </Text>
      </Box>

      <Box flexGrow="1" ml={1}>
        <Box display="flex" flexDirection="column">
          <Box position="relative">
            <Text variant="h6">{`${user.firstName} ${user.lastName}`}</Text>
          </Box>
        </Box>
      </Box>
    </AccountBox>

    <MenuBox>
      <MenuList id="account-menu" onClick={onClick}>
        { AccountMenuItems && <AccountMenuItems me={me} /> }

        <NavMenuItemWrapper>
          <MenuLink href="/logout" color="inherit" onClick={logout} onTouchEnd={logout}>
            <LogoutIcon sx={{ marginRight: 1 }} />
            Logout
          </MenuLink>
        </NavMenuItemWrapper>
      </MenuList>
    </MenuBox>

  </Box>
}

export default Footer
